
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.5 8a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z","stroke":"currentColor"}}),_c('path',{attrs:{"d":"M10.858 8.572H7.43v-4","stroke":"currentColor","stroke-miterlimit":"10"}})])
          )
        }
      }
    